// 共享常量 —— 从 EpisodeStoryboardBoardWorkbench.jsx 抽出
// 所有视觉/业务常量统一在这里维护，便于调整。

export const SURFACE = {
  page: "var(--color-bg-primary)",
  panel: "var(--color-bg-secondary)",
  card: "var(--color-bg-card)",
  soft: "var(--color-bg-tertiary)",
  input: "var(--color-bg-overlay)",
};

export const REF_LIMIT = 16;
export const VIDEO_REF_LIMIT = 16;
export const BOARD_COUNT = 10;
export const BOARD_SECONDS = 15;
export const SHOW_LEGACY_STORYBOARD_LAYOUT = false;

// GuaVideo 相关
export const GUA_VIDEO_MODEL = "doubao-seedance-2-0-260128";
export const GUA_VIDEO_RESOLUTION = "720p";
export const DEFAULT_VIDEO_RATIO = "9:16";
export const DEFAULT_VIDEO_LIGHTING = "standard";
export const GUA_VIDEO_RATIOS = ["adaptive", "16:9", "4:3", "1:1", "3:4", "9:16", "21:9"];
export const GUA_VIDEO_RESOLUTIONS = ["480p", "720p"];

// 去字幕开关的提示词
export const NO_SUBTITLE_PROMPT = "禁止字幕、角标、水印、故事板页面文字和说明文字入画；不要生成任何上屏文字。\n";
